module.exports = __webpack_public_path__ + "house-twilight-neon.d606c8732bfab087425a.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/assets/img/house-twilight-neon.svg
// module id = ../../../../../src/assets/img/house-twilight-neon.svg
// module chunks = main